import React, { createContext, useContext, useState, useEffect } from 'react';

const LocaleContext = createContext();

const translations = {
  en: {
    // Navigation
    'nav.home': 'Home',
    'nav.about': 'About',
    'nav.projects': 'Projects',
    'nav.updates': 'Updates',
    'nav.investment': 'Investment',
    'nav.gallery': 'Gallery',
    'nav.contact': 'Contact',
    'nav.enquire': 'Enquire Now',

    // Buttons & CTAs
    'btn.explore_mall': 'Explore Prime Mall',
    'btn.view_projects': 'View Projects',
    'btn.request_details': 'Request Investment Details',
    'btn.download_brochure': 'Download Brochure',
    'btn.request_pricing': 'Request Pricing',
    'btn.book_visit': 'Book Site Visit',
    'btn.whatsapp_enquiry': 'WhatsApp Enquiry',
    'btn.submit': 'Submit Enquiry',
    'btn.next': 'Next Step',
    'btn.prev': 'Previous',
    'btn.saving': 'Sending...',
    'btn.view_details': 'View Details',
    'btn.invest_opportunity': 'Explore Investment Opportunity',

    // Headings / Content
    'home.hero_title': 'Commercial Landmarks for Business Growth',
    'home.hero_sub': 'Prime Business Zone develops premium retail and office destinations in Islamabad, planned for visibility, access, investor confidence, and long-term commercial value.',
    'home.completed_proof': 'Completed Project & Proof of Delivery',
    'home.development_philosophy': 'Development Philosophy',
    'home.business_statistics': 'Business Statistics',
    'home.latest_updates': 'Latest Construction Updates',
    'home.investment_cta': 'Secure Your Commercial Share',
    'home.investment_cta_sub': 'Speak with our investment team for current availability, pricing guidance, payment plans, and private site visits.',
    'home.contact_title': 'Our Offices & Locations',

    // Project statuses
    'project.under_construction': 'Under Construction',
    'project.completed': 'Completed',
    'project.ongoing': 'Ongoing',
    'project.upcoming': 'Upcoming',
    'project.status': 'Status',
    'project.location': 'Location',
    'project.progress': 'Progress',
    'project.highlights': 'Highlights',
    'project.amenities': 'Amenities & Facilities',
    'project.floor_plans': 'Interactive Floor Plans',
    'project.timeline': 'Construction Timeline',
    'project.gallery': 'Project Media Gallery',
    'project.unit_types': 'Available Categories',

    // Floor plans & Units
    'units.title': 'Interactive Unit Navigator',
    'units.select_floor': 'Select Floor Level',
    'units.number': 'Unit Number',
    'units.area': 'Area (Sq.Ft)',
    'units.type': 'Category',
    'units.price': 'Price',
    'units.status': 'Availability',
    'units.available': 'Available',
    'units.reserved': 'Reserved',
    'units.sold': 'Sold',
    'units.enquire': 'Enquire about Unit',
    'units.legend': 'Unit Availability Legend',

    // Investment form
    'invest.stepper_title': 'Investment Enquiry Portal',
    'invest.step1': 'Select Project',
    'invest.step2': 'Investment Category',
    'invest.step3': 'Budget Range',
    'invest.step4': 'Personal Details',
    'invest.step5': 'Confirmation',
    'invest.select_project_label': 'Choose landmark:',
    'invest.select_type_label': 'Select unit category:',
    'invest.select_budget_label': 'Choose budget bracket (PKR):',
    'invest.name_label': 'Full Name',
    'invest.phone_label': 'Phone / WhatsApp',
    'invest.email_label': 'Email Address',
    'invest.message_label': 'Additional Requirements (Optional)',
    'invest.success_title': 'Thank You!',
    'invest.success_msg': 'Your enquiry has been securely logged. An investment manager will call you shortly.',

    // Contact Page
    'contact.title': 'Connect With Us',
    'contact.hours': 'Working Hours',
    'contact.form_title': 'General Feedback & Queries',
    'contact.visit_title': 'Schedule a Private Site Tour',
    'contact.preferred_date': 'Preferred Date',
    'contact.preferred_time': 'Preferred Time Slot',

    // Localization switcher
    'lang.switcher': 'EN / اردو',
  },
  ur: {
    // Navigation
    'nav.home': 'ہوم',
    'nav.about': 'ہمارے بارے میں',
    'nav.projects': 'پروجیکٹس',
    'nav.updates': 'اپ ڈیٹس',
    'nav.investment': 'سرمایہ کاری',
    'nav.gallery': 'گیلری',
    'nav.contact': 'رابطہ',
    'nav.enquire': 'رابطہ کریں',

    // Buttons & CTAs
    'btn.explore_mall': 'پرائم مال دیکھئے',
    'btn.view_projects': 'تمام پروجیکٹس',
    'btn.request_details': 'سرمایہ کاری کی معلومات حاصل کریں',
    'btn.download_brochure': 'بروشر ڈاؤن لوڈ کریں',
    'btn.request_pricing': 'قیمت معلوم کریں',
    'btn.book_visit': 'دورے کا وقت طے کریں',
    'btn.whatsapp_enquiry': 'واٹس ایپ رابطہ',
    'btn.submit': 'درخواست جمع کروائیں',
    'btn.next': 'اگلا مرحلہ',
    'btn.prev': 'پیچھے',
    'btn.saving': 'جمع کیا جا رہا ہے...',
    'btn.view_details': 'مزید تفصیلات',
    'btn.invest_opportunity': 'سرمایہ کاری کے مواقع تلاش کریں',

    // Headings / Content
    'home.hero_title': 'کمرشل لینڈ مارکس کی تعمیر',
    'home.hero_sub': 'پرائم بزنس زون سوچ سمجھ کر ڈیزائن کی گئی کمرشل سائٹس تیار کرتا ہے جو کاروبار، سرمایہ کاری اور طویل مدتی قدر کے لیے بنائی گئی ہیں۔',
    'home.completed_proof': 'کامیابی کے ساتھ مکمل شدہ منصوبہ',
    'home.development_philosophy': 'ہمارا ترقیاتی فلسفہ',
    'home.business_statistics': 'کاروباری اعداد و شمار',
    'home.latest_updates': 'تعمیراتی کام کی تازہ ترین صورتحال',
    'home.investment_cta': 'اپنا کمرشل حصہ محفوظ کریں',
    'home.investment_cta_sub': 'افتتاحی قیمتوں پر ریٹیل یونٹس حاصل کرنے کے لیے ہمارے سرمایہ کاری کے ماہرین سے رابطہ کریں۔',
    'home.contact_title': 'ہمارے دفاتر اور مقامات',

    // Project statuses
    'project.under_construction': 'زیر تعمیر',
    'project.completed': 'مکمل شدہ',
    'project.ongoing': 'جاری',
    'project.upcoming': 'عنقریب',
    'project.status': 'حیثیت',
    'project.location': 'مقام',
    'project.progress': 'ترقیاتی پیش رفت',
    'project.highlights': 'اہم خصوصیات',
    'project.amenities': 'سہولیات اور خدمات',
    'project.floor_plans': 'انٹرایکٹو فلور پلانز',
    'project.timeline': 'تعمیراتی ٹائم لائن',
    'project.gallery': 'پروجیکٹ گیلری',
    'project.unit_types': 'دستیاب کیٹیگریز',

    // Floor plans & Units
    'units.title': 'انٹرایکٹو یونٹ نیویگیٹر',
    'units.select_floor': 'فلور منتخب کریں',
    'units.number': 'یونٹ نمبر',
    'units.area': 'رقبہ (مربع فٹ)',
    'units.type': 'کیٹیگری',
    'units.price': 'قیمت',
    'units.status': 'دستیابی',
    'units.available': 'دستیاب',
    'units.reserved': 'بک شدہ',
    'units.sold': 'فروخت شدہ',
    'units.enquire': 'یونٹ کے بارے میں پوچھیں',
    'units.legend': 'یونٹس کی دستیابی کے اشارے',

    // Investment form
    'invest.stepper_title': 'سرمایہ کاری پورٹل',
    'invest.step1': 'پروجیکٹ منتخب کریں',
    'invest.step2': 'سرمایہ کاری کیٹیگری',
    'invest.step3': 'بجٹ کی حد',
    'invest.step4': 'ذاتی معلومات',
    'invest.step5': 'تصدیق',
    'invest.select_project_label': 'پروجیکٹ منتخب کریں:',
    'invest.select_type_label': 'یونٹ کیٹیگری منتخب کریں:',
    'invest.select_budget_label': 'بجٹ کی حد منتخب کریں (روپے):',
    'invest.name_label': 'مکمل نام',
    'invest.phone_label': 'فون نمبر / واٹس ایپ',
    'invest.email_label': 'ای میل ایڈریس',
    'invest.message_label': 'اضافی ضروریات (اختیاری)',
    'invest.success_title': 'بہت شکریہ!',
    'invest.success_msg': 'آپ کی معلومات محفوظ کر لی گئی ہیں۔ ہمارا نمائندہ جلد آپ سے رابطہ کرے گا۔',

    // Contact Page
    'contact.title': 'ہم سے رابطہ کریں',
    'contact.hours': 'کام کے اوقات',
    'contact.form_title': 'عام معلومات اور سوالات',
    'contact.visit_title': 'سائٹ کے معائنے کا وقت طے کریں',
    'contact.preferred_date': 'پسندیدہ تاریخ',
    'contact.preferred_time': 'پسندیدہ وقت',

    // Localization switcher
    'lang.switcher': 'EN / اردو',
  }
};

export const LocaleProvider = ({ children }) => {
  const locale = 'en';
  const setLocale = () => {};

  useEffect(() => {
    localStorage.setItem('pbz_locale', 'en');
    const htmlElement = document.documentElement;
    htmlElement.setAttribute('dir', 'ltr');
    htmlElement.setAttribute('lang', 'en');
    htmlElement.classList.remove('rtl-mode');
  }, []);

  const toggleLocale = () => {
    localStorage.setItem('pbz_locale', 'en');
  };

  const t = (key, defaultText = '') => {
    return translations[locale]?.[key] || defaultText || key;
  };

  return (
    <LocaleContext.Provider value={{ locale, setLocale, toggleLocale, t, isRtl: false }}>
      {children}
    </LocaleContext.Provider>
  );
};

export const useLocale = () => {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }
  return context;
};
